/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Product,
    ProductFromJSON,
    ProductFromJSONTyped,
    ProductToJSON,
} from './';

/**
 * 
 * @export
 * @interface ListProductsResponse
 */
export interface ListProductsResponse {
    /**
     * 
     * @type {Array<Product>}
     * @memberof ListProductsResponse
     */
    products?: Array<Product>;
}

export function ListProductsResponseFromJSON(json: any): ListProductsResponse {
    return ListProductsResponseFromJSONTyped(json, false);
}

export function ListProductsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListProductsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'products': !exists(json, 'products') ? undefined : ((json['products'] as Array<any>).map(ProductFromJSON)),
    };
}

export function ListProductsResponseToJSON(value?: ListProductsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'products': value.products === undefined ? undefined : ((value.products as Array<any>).map(ProductToJSON)),
    };
}


